<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="flex flex-wrap justify-content-end">
        <div *ngIf="machine?.model.machineType === 'ZITRUX'" class="flex">
          <span class="line-height-4 mr-1">
            <span class="text-xl font-semibold">{{'common.viewInLiters' | transloco}}</span>&nbsp;
          </span>
          <div class="mr-4 mt-1">
            <p-inputSwitch [(ngModel)]="viewInLiters" (onChange)="changeLiters($event)" [disabled]="this.isMachineLoading || this.isGeneralInfoLoading"></p-inputSwitch>
          </div>
        </div>
        <button
          [disabled]="this.isMachineLoading || isGeneralInfoLoading"
          [label]="'common.exportXls' | transloco"
          (click)="exportVisible = !exportVisible"
          pButton
          class="p-button-secondary md:mr-2"
          icon="pi pi-file-excel"
        ></button>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-4">
    <div class="card h-30rem">
      <div class="card-header h-3rem pt-1">
        <h4 *ngIf="!this.isMachineLoading" class="mt-auto mb-auto">
          {{machine.alias}}
          <span *ngIf="machine.deleted"> ({{'attribute.deleted' | transloco}})</span>
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading" width="40%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div class="image flex h-24rem">
        <img *ngIf="!this.isMachineLoading" class="max-w-full h-20rem m-auto" [src]="machine.model.image"
             [ngClass]="{'img-deleted': machine.deleted}" alt="{{ 'attribute.machineImage' | transloco}}">
        <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="20rem"></p-skeleton>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-4">
    <div class="grid">
      <div class="col-12 lg:col-6" *ngIf="!viewInLiters">
        <div class="card relative" [ngStyle]="{height: '14.5rem'}">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.general.totalSqueezedFruitsCounter' | transloco}}"
               tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 *ngIf="!this.isMachineLoading" class="mt-auto mb-auto">
              {{'misc.overview.totalSqueezedFruitsCounter' | transloco}}
            </h4>
            <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
          </div>
          <hr>
          <div class="flex h-8rem">
            <span class="m-auto text-400 font-medium text-xl"
                  *ngIf="!this.isMachineLoading && (this.machine.telemetryData?.totalSqueezedFruits == null || this.machine.telemetryData?.totalSqueezedFruits == undefined)">
                        {{'empty.measures' | transloco}}</span>
            <span class="m-auto text-primary font-semibold text-5xl"
                  *ngIf="!this.isMachineLoading && machine.telemetryData?.totalSqueezedFruits != null">
                        {{machine.telemetryData.totalSqueezedFruits | number: '' : this.language}}</span>
            <p-skeleton class="m-auto" *ngIf="this.isMachineLoading" width="30%" height="3rem"></p-skeleton>
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-6" *ngIf="viewInLiters">
        <div class="card relative" [ngStyle]="{height: '14.5rem'}">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.general.totalSqueezedLitersCounter' | transloco}}"
               tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 *ngIf="!this.isMachineLoading" class="mt-auto mb-auto">
              {{'misc.overview.totalSqueezedLitersCounter' | transloco}}
            </h4>
            <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
          </div>
          <hr>
          <div class="flex h-8rem">
            <span class="m-auto text-400 font-medium text-xl"
                  *ngIf="!this.isMachineLoading && (this.machine.telemetryData?.totalSqueezedLiters == null || this.machine.telemetryData?.totalSqueezedLiters == undefined)">
                        {{'empty.measures' | transloco}}</span>
            <span class="m-auto text-primary font-semibold text-5xl"
                  *ngIf="!this.isMachineLoading && machine.telemetryData?.totalSqueezedLiters != null">
                        {{machine.telemetryData.totalSqueezedLiters | number: '.3-3' : this.language}}</span>
            <p-skeleton class="m-auto" *ngIf="this.isMachineLoading" width="30%" height="3rem"></p-skeleton>
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-6">
        <div class="card relative" [ngStyle]="{height: '14.5rem'}">
          <div class="absolute top-0 left-0" [pTooltip]="partialSqueezedValuesTranslation" tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 *ngIf="!this.isGeneralInfoLoading" class="mt-auto mb-auto">
              <span *ngIf="!viewInLiters">{{'misc.overview.partialSqueezedFruitsCounter' | transloco}}</span>
              <span *ngIf="viewInLiters">{{'misc.overview.partialSqueezedLitersCounter' | transloco}}</span>
            </h4>
            <p-skeleton *ngIf="this.isGeneralInfoLoading" width="100%" height="2rem"></p-skeleton>
          </div>
          <hr>
          <div class="flex h-8rem">
            <span class="m-auto text-400 font-medium text-xl"
                  *ngIf="!this.isGeneralInfoLoading && (this.machineGeneralInfo?.partialSqueezedValuesCounter == null || this.machineGeneralInfo?.partialSqueezedValuesCounter == undefined)">
                        {{'empty.measures' | transloco}}</span>
            <span class="m-auto text-primary font-semibold text-5xl"
                  *ngIf="!this.isGeneralInfoLoading && this.machineGeneralInfo?.partialSqueezedValuesCounter != null">
                        {{machineGeneralInfo?.partialSqueezedValuesCounter | number: viewInLiters ? '.3-3' : '' : this.language}}</span>
            <p-skeleton class="m-auto" *ngIf="this.isGeneralInfoLoading" width="30%" height="3rem"></p-skeleton>
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-6">
        <div class="card" [ngStyle]="{height: '14.5rem'}">
          <div class="card-header h-3rem pt-1">
            <h4 *ngIf="!this.isMachineLoading" class="mt-auto mb-auto">
              {{ 'attribute.lastValueReported' | transloco}}
            </h4>
            <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
          </div>
          <hr>
          <div class="flex h-8rem">
        <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!this.isMachineLoading && !machine.telemetryData?.lastValueReported">
          {{'empty.measures' | transloco}}
        </span>
            <h4 class="text-primary font-semibold m-auto text-center"
                *ngIf="!isMachineLoading && machine.telemetryData?.lastValueReported">
              {{machine.telemetryData.lastValueReported | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}
            </h4>
            <p-skeleton class="m-auto" *ngIf="this.isMachineLoading" width="50%" height="2rem"></p-skeleton>
          </div>
        </div>
      </div>

      <div class="col-12 lg:col-6">
        <div class="card relative" [ngStyle]="{height: '14.5rem'}">
          <div class="absolute top-0 left-0" pTooltip="{{'misc.info.general.workDailyCounter' | transloco}}"
               tooltipPosition="top">
            <div class="info-background">
              <i class="pi pi-info" style="font-size: 0.8rem"></i>
            </div>
          </div>
          <div class="card-header h-3rem pt-1">
            <h4 *ngIf="!this.isGeneralInfoLoading" class="mt-auto mb-auto">
              {{ 'misc.overview.workDailyCounter' | transloco}}
            </h4>
            <p-skeleton *ngIf="this.isGeneralInfoLoading" width="100%" height="2rem"></p-skeleton>
          </div>
          <hr>
          <div class="flex h-8rem">
            <span class="m-auto text-400 font-medium text-xl"
                  *ngIf="!this.isGeneralInfoLoading && (this.machineWorkDailyCounter == null || this.machineWorkDailyCounter == undefined)">
                        {{'empty.measures' | transloco}}</span>
            <span class="m-auto text-primary font-semibold text-5xl"
                  *ngIf="!this.isGeneralInfoLoading && this.machineWorkDailyCounter != null">
                        {{machineWorkDailyCounter}}</span>
            <p-skeleton class="m-auto" *ngIf="this.isGeneralInfoLoading" width="30%" height="3rem"></p-skeleton>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="col-12 lg:col-4">
    <div class="card h-30rem">
      <div class="card-header h-3rem pt-1">
        <h4 *ngIf="!this.isMachineLoading" class="mt-auto mb-auto">
          {{ 'misc.overview.geolocation' | transloco }}
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div id="map" class="h-20rem">
        <div *ngIf="this.isMachineLoading">
          <p-skeleton width="100%" height="20rem"></p-skeleton>
        </div>
      </div>
      <div class="flex" [ngStyle]="{height: '3.5rem'}">
        <div class="mt-auto mb-auto">
          <div *ngIf="!this.isMachineLoading">
            {{machine.geocoding.locality[language]}} ({{machine.geocoding.state[language]}},
            {{machine.geocoding.country[language]}})
          </div>
          <p-skeleton *ngIf="this.isMachineLoading" width="80%" height="1rem"></p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-6 xl:col-4">
    <div class="card relative h-20rem">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesByHourOfLastDayTranslation" tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isMachineLoading && !this.isGeneralInfoLoading">
          <span *ngIf="!viewInLiters">{{'misc.overview.squeezedFruitsByHourOfLastDay' | transloco}}</span>
          <span *ngIf="viewInLiters">{{'misc.overview.squeezedLitersByHourOfLastDay' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isGeneralInfoLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div #squeezedValuesByHourOfDayDiv class="flex h-12rem">
        <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!this.isGeneralInfoLoading && this.squeezedValuesByHourOfDay.data == null">
            {{'empty.measures' | transloco}}
        </span>
        <span *ngIf="!this.isGeneralInfoLoading && this.squeezedValuesByHourOfDay.data != null"
              class="m-auto text-primary font-semibold text-5xl text-center">
          <app-generic-graph name="squeezedFruitsByHourOfDay" [dataType]="'category'"
                             [categories]="this.squeezedValuesByHourOfDay.categories"
                             [data]="this.squeezedValuesByHourOfDay.data"
                             [height]="170" [width]="this.squeezedValuesByHourOfDayDivWidth"
                             chartType="column" class="mt-3" [(update)]="updateFlag"
                             [pointFormat]="this.tooltipFormatter(this.squeezedValuesTranslation)"
                             [plotOptions]="plotOptions">
          </app-generic-graph>
        </span>
        <div class="w-full" *ngIf="this.isGeneralInfoLoading">
          <p-skeleton class="m-auto" height="170px">
          </p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-6 xl:col-4">
    <div class="card relative h-20rem">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesLastDay" tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isGeneralInfoLoading">
          <span *ngIf="!viewInLiters">{{'misc.overview.squeezedFruitsLastDay' | transloco}}</span>
          <span *ngIf="viewInLiters">{{'misc.overview.squeezedLitersLastDay' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isGeneralInfoLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div #squeezedValuesMeasurementsDiv class="flex h-12rem">
        <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!this.isGeneralInfoLoading && (!this.squeezedValuesMeasurements || this.squeezedValuesMeasurements?.length == 0)">
            {{'empty.measures' | transloco}}
        </span>
        <span *ngIf="!this.isGeneralInfoLoading && this.squeezedValuesMeasurements?.length > 0">
          <app-generic-graph [customSeries]="false"
                             [data]="this.squeezedValuesMeasurements" [height]="170" [legend]="false"
                             [name]="'attribute.value' | transloco" chartType="line"
                             tooltipDateFormat="%A, %e %b %Y, %H:%M:%S %Z"
                             [width]="this.squeezedValuesMeasurementsDivWidth" [(update)]="updateFlag"
                             [pointFormat]="this.tooltipFormatter(this.squeezedValuesTranslation)"
                             [plotOptions]="plotOptions">
          </app-generic-graph>
        </span>
        <div class="w-full" *ngIf="this.isGeneralInfoLoading">
          <p-skeleton class="m-auto" height="170px">
          </p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-12 xl:col-4">
    <div class="card relative h-20rem">
      <div class="absolute top-0 left-0" pTooltip="{{'misc.info.general.alarmDistribution' | transloco}}"
           tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isGeneralInfoLoading">
          {{'misc.overview.alarmDistribution' | transloco}}
        </h4>
        <p-skeleton *ngIf="this.isGeneralInfoLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div *ngIf="!this.isGeneralInfoLoading && (!this.authGuard.isECommerce() || machine?.subscription?.active)">
        <app-generic-graph *ngIf="!this.isGeneralInfoLoading" [data]="alarmDistribution"
                           [categories]="this.alarmDistributionCategories" [name]="'attribute.value' | transloco"
                           [height]="170"
                           [legend]="true" [customSeries]="true" chartType="pie"
                           [plotOptions]="{pie: {dataLabels: {enabled: false}, showInLegend: true}}"
                           [pointFormat]="this.pointFormatPieChart" dataType="category">
        </app-generic-graph>
      </div>
      <div *ngIf="!this.isGeneralInfoLoading && this.authGuard.isECommerce() && !machine?.subscription?.active" class="flex h-12rem">
        <span class="m-auto text-400 font-medium text-xl" *ngIf="!this.isMachineLoading">
                    {{'empty.noSubscription' | transloco}}</span>
      </div>
      <div *ngIf="this.isGeneralInfoLoading" [ngStyle]="{width: '170px'}" class="m-auto">
        <p-skeleton shape="circle" height="170px"></p-skeleton>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-6 xl:col-4">
    <div class="card h-full">
      <div class="card-header h-3rem pt-1">
        <h4 *ngIf="!this.isMachineLoading" class="mt-auto mb-auto">
          {{ 'misc.overview.machineInfo' | transloco }}
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div class="grid" *ngIf="!this.isMachineLoading && !this.isGeneralInfoLoading">
        <div class="col-12">
          <b>{{ 'attribute.serialNumber' | transloco}}: </b>{{ machine.serial }}
        </div>
        <div class="col-12">
          <b>{{ 'attribute.simNumber' | transloco}}: </b>
          <span *ngIf="machine.simNumber">{{ machine.simNumber }}</span>
          <span *ngIf="!machine.simNumber">N/A</span>
        </div>
        <div class="col-12">
          <b>{{ 'attribute.model' | transloco}}: </b>{{ machine.model.modelName }}
        </div>
        <div class="col-12">
          <b>{{ 'model.organization' | transloco}}: </b>{{machine.organization.name}} ({{machine.organization.orgCode}})
        </div>
        <div class="col-12">
          <b>{{ 'misc.overview.telemetryKitNumber' | transloco}}: </b>
          <span *ngIf="machine.telemetryData.integrationIdentifier">&nbsp;{{ machine.telemetryData.integrationIdentifier }}</span>
          <span *ngIf="!machine.telemetryData.integrationIdentifier">N/A</span>
        </div>
        <div class="col-12">
          <b>{{ 'attribute.activationDate' | transloco}}: </b>
          <span>{{machine.manufacturingDate | date:'mediumDate': authGuard.getOffset(): authGuard.getLanguage() }}</span>
        </div>
        <div class="col-12">
          <b>{{ 'attribute.communicationType' | transloco}}: </b>
          <span
            *ngIf="machine.telemetryData.communicationType != undefined && machine.telemetryData.communicationType === 0">{{'attribute.gprs' | transloco }}</span>
          <span
            *ngIf="machine.telemetryData.communicationType != undefined && machine.telemetryData.communicationType === 1">{{'attribute.wifi' | transloco }}</span>
          <span *ngIf="machine.telemetryData.communicationType == undefined">N/A</span>
        </div>
        <div class="col-12">
          <b>{{ 'attribute.automaticGeoloc' | transloco}}: </b>
          <span *ngIf="machine.automaticGeoloc">{{ 'attribute.yes' | transloco }}</span>
          <span *ngIf="!machine.automaticGeoloc">{{ 'attribute.no' | transloco }}</span>
        </div>
        <div class="col-12" *ngIf="machine.model.description">
          <b>{{ 'attribute.descriptionModel' | transloco}}: </b>
          <span>&nbsp;{{ machine.model.description }}</span>
        </div>
      </div>
      <div *ngIf="this.isMachineLoading || this.isGeneralInfoLoading">
        <div class="grid">
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-4">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
          <div class="col-8">
            <p-skeleton width="100%" height="1rem"></p-skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-6 xl:col-4">
    <div class="card h-full">
      <div class="card-header h-3rem pt-1">
        <h4 *ngIf="!this.isMachineLoading" class="mt-auto mb-auto">
          {{ 'misc.overview.machineStatus' | transloco }}
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div class="grid" *ngIf="!this.isMachineLoading && (!this.authGuard.isECommerce() || machine?.subscription?.active)">
        <div class="col-6 p-0">
          <div *ngIf="!this.authGuard.isECommerce()" class="col-12">
            <b>{{ 'misc.overview.workingHours' | transloco}}: </b>
            <span *ngIf="machine.telemetryData?.workHours != null && machine.telemetryData?.workHours != undefined">
                            {{machine.telemetryData.workHours - machine.telemetryData.initialWorkHours}}&nbsp;{{'time.hours' |transloco}}</span>
            <span
              *ngIf="machine.telemetryData?.workHours == null || machine.telemetryData?.workHours == undefined">N/A</span>
          </div>
          <div *ngIf="this.authGuard.isECommerce()" class="col-12">
            <b>{{ 'misc.overview.workingHours' | transloco}}: </b>
            <span *ngIf="machineGeneralInfo?.subscriptionWorkHours != null && machineGeneralInfo?.subscriptionWorkHours != undefined">
                            {{machineGeneralInfo?.subscriptionWorkHours}}&nbsp;{{'time.hours' |transloco}}</span>
            <span
              *ngIf="machineGeneralInfo?.subscriptionWorkHours == null || machineGeneralInfo?.subscriptionWorkHours == undefined">N/A</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.machineAge' | transloco}}: </b>
            <span *ngIf="machine.telemetryData?.machineAge != null && machine.telemetryData?.machineAge != undefined">
                          {{machine.telemetryData.machineAge}} {{'time.years' |transloco}}</span>
            <span *ngIf="machine.telemetryData?.machineAge == null || machine.telemetryData?.machineAge == undefined">N/A</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.powerOnTime' | transloco}}: </b>
            <span *ngIf="machine.telemetryData?.powerOnTime">{{machine.telemetryData?.powerOnTime | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}</span>
            <span *ngIf="!machine.telemetryData?.powerOnTime">N/A&nbsp;</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.powerOffTime' | transloco}}: </b>
            <span
              *ngIf="!machine.telemetryData.isPoweredOn && machine.telemetryData?.powerOffTime">{{machine.telemetryData?.powerOffTime | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}</span>
            <span *ngIf="machine.telemetryData.isPoweredOn">{{'attribute.isOn' | transloco}}</span>
            <span *ngIf="!machine.telemetryData?.powerOffTime && !machine.telemetryData?.powerOnTime">N/A</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.connection' | transloco}}: </b>
            <span *ngIf="machine.telemetryData?.isOn">{{'attribute.connected' | transloco}}</span>
            <span *ngIf="!machine.telemetryData?.isOn">{{'attribute.disconnected' | transloco}}</span>
          </div>
        </div>
        <div class="col-6 p-0">
          <div class="col-12 text-center">
            <p-tag *ngIf="machine.telemetryData.isPoweredOn" value="{{'attribute.on' | transloco}}"
                   class="green-tag"></p-tag>
            <p-tag *ngIf="!machine.telemetryData.isPoweredOn" value="{{'attribute.off' | transloco}}"
                   class="gray-tag"></p-tag>
          </div>
          <div class="col-12 text-center">
            <p-tag *ngIf="machine.telemetryData?.hasAlarms" value="{{'attribute.hasAlarms' | transloco}}"
                   class="red-tag cursor-pointer" (click)="redirectToAlarms()"></p-tag>
            <p-tag *ngIf="!machine.telemetryData?.hasAlarms" value="{{'attribute.noAlarms' | transloco}}"
                   class="green-tag"></p-tag>
          </div>
          <div *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')"
               class="col-12 text-center">
            <p-tag *ngIf="machine.telemetryData?.hasEvents" value="{{'attribute.hasEvents' | transloco}}"
                   class="yellow-tag cursor-pointer" (click)="redirectToAlarms()"></p-tag>
            <p-tag *ngIf="!machine.telemetryData?.hasEvents" value="{{'attribute.noEvents' | transloco}}"
                   class="green-tag"></p-tag>
          </div>
        </div>
      </div>
      <div *ngIf="!this.isMachineLoading && this.authGuard.isECommerce() && !machine?.subscription?.active" class="flex h-18rem">
        <span class="m-auto text-400 font-medium text-xl" *ngIf="!this.isMachineLoading">
          {{'empty.noSubscription' | transloco}}
        </span>
      </div>
      <div *ngIf="this.isMachineLoading">
        <div class="grid">
          <div class="col-6">
            <div class="grid">
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
              <div class="col-6">
                <p-skeleton width="100%" height="1rem"></p-skeleton>
              </div>
            </div>
          </div>
          <div class="col-6 p-0">
            <div class="col-12">
              <p-skeleton width="100%" height="4rem"></p-skeleton>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="4rem"></p-skeleton>
            </div>
            <div class="col-12">
              <p-skeleton width="100%" height="4rem"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="authGuard.hasPermission('PERMISSION_VIEW_ALARMS')" class="col-12 lg:col-12 xl:col-4">
    <div class="card h-full">
      <div class="card-header h-3rem pt-1">
        <h4 *ngIf="!this.isMachineLoading" class="mt-auto mb-auto">
          {{ 'attribute.activeAlarms' | transloco }}
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div *ngIf="!this.authGuard.isECommerce() || machine?.subscription?.active">
        <p-table [value]="this.activeAlarms" breakpoint="1600px" responsiveLayout="scroll"
                 styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">{{'attribute.name' | transloco }}</th>
              <th scope="col">{{'attribute.activationDate' | transloco }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-alarm>
            <tr *ngIf="!this.isMachineLoading">
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                {{alarm.name}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.activationDate' | transloco}}</span>
                {{alarm.activationDate | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}
              </td>
            </tr>
            <tr *ngIf="this.isMachineLoading">
              <td>
                <p-skeleton width="100%"></p-skeleton>
              </td>
              <td>
                <p-skeleton width="100%"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div *ngIf="this.isAlarmsLoading || !this.activeAlarms || this.activeAlarms?.length == 0"
                 class="flex align-items-center justify-content-between">{{'attribute.noAlarms' | transloco}}</div>
            <div *ngIf="!this.isAlarmsLoading && this.activeAlarms?.length > 0"
                 class="flex align-items-center justify-content-between">
              {{'attribute.alarmTotal' | transloco}}: {{this.activeAlarms.length}}
            </div>
          </ng-template>
        </p-table>
      </div>
      <div *ngIf="this.authGuard.isECommerce() && !machine?.subscription?.active" class="flex h-18rem">
        <span class="m-auto text-400 font-medium text-xl" *ngIf="!this.isMachineLoading">
          {{'empty.noSubscription' | transloco}}
        </span>
        <p-skeleton class="m-auto" *ngIf="this.isMachineLoading" width="30%" height="3rem"></p-skeleton>
      </div>
    </div>
  </div>
</div>

<app-export-xls *ngIf="exportVisible"
                [content]="getContentExport()"
                [machineSerialNumber]="machine.serial"
                [typeContent]="'MACHINE_GENERAL'"
                [exportFileType]="ExportFileType.MACHINE_GENERAL"
                [typeExport]="'XLSX'"
                [(visible)]="exportVisible">
</app-export-xls>
